export const STORAGE_KEYS = {
  memory: "lumen-refinery-memory-v2",
  mastered: "lumen-refinery-mastered-v2",
  preMasterMemory: "lumen-refinery-pre-master-memory-v1",
  name: "lumen-refinery-display-name-v1",
};
